import { isValid } from 'date-fns';

import { TranscriptEntry } from '../../../platform-call';

export function filterQuotesByTimeRange(
    timeRange: { from: number; to: number } | null,
    startTimestamp: Date,
    quotes: TranscriptEntry[],
): TranscriptEntry[] {
    if (
        timeRange == null ||
        timeRange.from == null ||
        timeRange.to == null ||
        !isValid(startTimestamp)
    ) {
        return [...quotes];
    }

    return quotes.filter((q) => {
        const secs = (q.endTime.getTime() - startTimestamp.getTime()) / 1000;
        return secs >= timeRange.from && secs <= timeRange.to;
    });
}
